import React, { useEffect, useState } from "react";
import { axios } from "../../../../../Global";
import { CiEdit } from "react-icons/ci";
import { CgSpinner } from "react-icons/cg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import { IoSettingsOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import HeadingEdit from "../../Quotation/QuotationCostSheet/HeadingEdit";
import { ContractCostSheetHeadingEdit } from "../ContractSingleView/CostSheet/Edit/ContractCostSheetHeadingEdit";
import { getObjectValue } from "../../../../../utils/functions";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import SettingsPopup from "../../../../../ReusableComponents/SettingsPopup/SettingsPopup";
import { setAppError } from "../../../../../store/userSlice";
import PromptElement from "../../../PromptElement";
import { ContractCosheetCostplusHeadingEdit } from "./CostSheet/Edit/ContractCosheetCostplusHeadingEdit";

const ContractCostSheetTable = ({ contractDetails = {}, updateComponent }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const currentContractId = params?.contractId;
  const jobPositionArray = contractDetails?.job_possition;
  const visaProfessionArray = contractDetails?.visa_profession;
  const nationalityArray = contractDetails?.nationality;
  const professionalLevelArray = contractDetails?.profession_level;
  const costDetails = contractDetails?.contract_cost_sheet_cost_details;

  const [deletePopup, setDeletePopup] = useState({ open: false });

  const list =
    contractDetails?.contract_cost_sheet_profession_basic_information || [];

  const costHeadings = contractDetails?.contract_cost_sheet_headings;

  const [defaultFields, setDefaultFields] = useState([
    {
      id: 1,
      title: "Actual Profession",
      value: "job_position_id",
      width: "min-w-[12rem]",
      default: true,
      type: "array-value",
      array: jobPositionArray,
    },
    {
      id: 2,
      title: "VISA Profession",
      value: "visa_profession_id",
      width: "min-w-[10rem]",
      default: true,
      type: "array-value",
      array: visaProfessionArray,
    },
    {
      id: 3,
      title: "Quantity",
      value: "quantity",
      width: "min-w-[10rem]",
      default: true,
    },
    {
      id: 4,
      title: "Profession Level",
      value: "profession_level_id",
      width: "min-w-[10rem]",
      type: "array-value",
      array: professionalLevelArray,
    },

    {
      id: 5,
      title: "Nationality",
      value: "nationality_id",
      width: "min-w-[10rem]",
      type: "array-value",
      array: nationalityArray,
    },
    {
      id: 6,
      title: "Gender",
      value: "gender",
      width: "min-w-[8rem]",
    },
    {
      id: 7,
      title: "Created At",
      value: "created_at",
      width: "min-w-[8rem]",
      type: "longDate",
    },

    ...(contractDetails?.contract?.quotation_type?.name !== "Cost Plus"
      ? [
          {
            id: 8,
            title: "Total - Employee Salary Package",
            value: "1",
            width: "min-w-[12rem]",
            type: "totalSectionCost",
          },
          {
            id: 9,
            title: "Total - GOVERNMENT FEES",
            value: "2",
            width: "min-w-[12rem]",
            type: "totalSectionCost",
          },
          {
            id: 10,
            title: "Total - SOUNDLINE FEES",
            value: "3",
            width: "min-w-[12rem]",
            type: "totalSectionCost",
          },
        ]
      : []),

    {
      id: 11,
      title: "Total Monthly Per Head Cost",
      value: "",
      width: "min-w-[12rem]",
      type: "totalCost",
    },
  ]);

  const [selectedFields, setSelectedFields] = useState(
    defaultFields.filter((data) => data.default)
  );

  console.log(contractDetails, "contract details");
  useEffect(() => {
    if (contractDetails?.contract_cost_sheet_headings?.length > 0) {
      console.log("useEffect running");
      const allHeadings = contractDetails?.contract_cost_sheet_headings?.map(
        (heading) => {
          const headingTitle =
            heading?.rate_category_item?.name ||
            heading?.rate_category_item_name;
          return {
            id: heading?.id,
            title: headingTitle,
            width: String(headingTitle)
              .split(" ")
              .find((title) => title.length > 10)
              ? "min-w-[12rem]"
              : "min-w-[8rem]",
            type: heading?.type,
          };
        }
      );
      console.log(allHeadings, "all heading");

      // Filter out duplicates based on id and merge with existing setDefaultFields
      setDefaultFields((prevState) => {
        const uniqueHeadings = allHeadings.filter((heading) => {
          return !prevState.some(
            (prevHeading) => prevHeading.id === heading.id
          );
        });

        return [...prevState, ...uniqueHeadings];
      });
    }
  }, [contractDetails]);

  const [showSettings, setShowSettings] = useState(false);

  const [openHeadingEditPupup, setOpenHeadingEditPopup] = useState(false);
  const [openCostPlusHeadingEdit, setOpenCostPlusHeadingEdit] = useState(false);

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(list);

  const calculateTotalCost = (basicId) => {
    let totalCost = 0;
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.contract_cost_sheet_profession_basic_information_id == basicId
    );
    for (let currentCost of currentCostDetails) {
      totalCost = totalCost + Number(currentCost?.cost);
    }
    return Number(totalCost).toFixed(2);
  };

  const calculateSectionWiseCost = (basicId, rateCategoryId) => {
    let totalCost = 0;
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.contract_cost_sheet_profession_basic_information_id == basicId
    );

    const currentSectionHeadingsId = costHeadings
      ?.filter((heading) => heading?.rate_category_id == rateCategoryId)
      ?.map((heading) => heading?.id);

    currentSectionHeadingsId.map((headingId) => {
      currentCostDetails?.map((detail) => {
        if (headingId == detail?.contract_cost_sheet_heading_id) {
          totalCost += Number(detail?.cost);
        }
      });
    });

    return Number(totalCost).toFixed(2);
  };

  console.log(defaultFields, "ddefault fields");
  const getDefaultAndDynamicValues = (basicId, title = "") => {
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.contract_cost_sheet_profession_basic_information_id == basicId
    );
    console.log(costHeadings, "cost heading");
    const currentHeading = costHeadings?.find(
      (details) =>
        details?.rate_category_item_name == title ||
        details?.rate_category_item?.name == title
    );
    const currentCost = currentCostDetails.find(
      (details) => details?.contract_cost_sheet_heading_id == currentHeading?.id
    );
    console.log(currentCost);
    return currentCost?.cost;
  };

  const getNormalizedValue = (data, selectedData) => {
    switch (selectedData?.type) {
      case "longDate":
        return String(data[selectedData.value] || "-").split("T")[0];
      case "totalCost":
        return calculateTotalCost(data?.id);
      case "totalSectionCost":
        return calculateSectionWiseCost(data?.id, selectedData?.value);
      case "array-value":
        return selectedData?.array?.find(
          (value) => value?.id == data[selectedData.value]
        )?.name;
      case "Default":
        return getDefaultAndDynamicValues(data?.id, selectedData?.title);
      case "Dynamic":
        return getDefaultAndDynamicValues(data?.id, selectedData?.title);
      default:
        return String(data[selectedData.value] || "-");
    }
  };

  const editData = async (costSheetId, type = "EmployeeSalaryPackage") => {
    if (type === "Fees&Muqeem") {
      navigate(
        `/dashboard/contract/${currentContractId}/cost-sheet-edit-fees-muqeem`,
        {
          state: { method: "Edit", type },
        }
      );
    } else {
      navigate(
        `/dashboard/contract/${currentContractId}/cost-sheet-edit/${costSheetId}`,
        {
          state: { method: "Edit", type },
        }
      );
    }
  };
  const deleteData = async (id) => {
    if (id) {
      try {
        const response = await axios.delete(
          `/dashboard/contract-cost-sheet/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "success",
            })
          );

          // if (list?.quotation_cost_sheet?.length <= 1) {
          //   navigate(`/dashboard/contract/${contractDetails.contract.id}`);
          // } else {
          updateComponent((p) => Math.random());
          // }
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setDataLoaded(true);
    }, 2000);
  }, [list]);

  return (
    <>
      {openHeadingEditPupup &&
        contractDetails?.contract?.quotation_type?.name !== "Cost Plus" && (
          <ContractCostSheetHeadingEdit
            showPromptElement={openHeadingEditPupup}
            setShowPromptElement={setOpenHeadingEditPopup}
            contractDetails={contractDetails}
            setGetUpdatedData={updateComponent}
          />
        )}
      {openCostPlusHeadingEdit &&
        contractDetails?.contract?.quotation_type?.name === "Cost Plus" && (
          <ContractCosheetCostplusHeadingEdit
            showPromptElement={openCostPlusHeadingEdit}
            setShowPromptElement={setOpenCostPlusHeadingEdit}
            contractDetails={contractDetails}
            setGetUpdatedData={updateComponent}
          />
        )}
      {showSettings && (
        <SettingsPopup
          showPopup={showSettings}
          setShowPopup={setShowSettings}
          initialState={defaultFields}
          finalState={selectedFields}
          setFinalState={setSelectedFields}
        />
      )}
      {deletePopup.open && (
        <PromptElement
          showPromptElement={deletePopup}
          setShowPromptElement={setDeletePopup}
          deleteHandler={deleteData}
        />
      )}
      <div className="flex flex-wrap items-stretch text-xs-ultra sm:text-xs justify-between px-6 gap-3 mt-10">
        <div className="flex gap-3 items-stretch">
          {checkAccess("Quotation", "quotation-cost-sheet-create") &&
            contractDetails?.contract?.quotation_type?.name === "Cost Plus" && (
              <Link
                to={`cost-sheet-addnew/${contractDetails?.contract?.quotation_id}`}
                // state={{
                //   costSheetState: {
                //     govtFee:
                //       list?.quotation_type === "Cost Plus"
                //         ? "onetime_cost"
                //         : "monthly_cost",
                //     salaryAllowance: "monthly_cost",
                //     slaFees: "monthly_cost",
                //   },
                //   quotationId: currentQuotationId,
                //   quotationDetails: {
                //     number: list?.quotation?.quotation_number,
                //     name: list?.quotation?.name,
                //     type: list?.quotation_type,
                //     clientName: list?.client,
                //     clientSpecific: list?.quotation?.client?.client_specific,
                //     status: list?.quotation?.status,
                //     statusDate:
                //       list?.quotation?.status === "Approved"
                //         ? list?.quotation?.approved_date
                //         : list?.quotation?.status === "Rejected" &&
                //           list?.quotation?.rejected_date,
                //   },
                // }}
              >
                <button className="p-2 bg-red text-white rounded-md h-full">
                  <p className="flex gap-3 items-center">ADD PROFESSION</p>
                </button>
              </Link>
            )}
          {checkAccess("Quotation", "quotation-cost-sheet-create") &&
            contractDetails?.contract?.quotation_type?.name !== "Cost Plus" && (
              <Link
                to={`cost-sheet-addnew/${contractDetails?.contract?.quotation_id}`}
                // state={{
                //   costSheetState: {
                //     govtFee:
                //       list?.quotation_type === "Cost Plus"
                //         ? "onetime_cost"
                //         : "monthly_cost",
                //     salaryAllowance: "monthly_cost",
                //     slaFees: "monthly_cost",
                //   },
                //   quotationId: currentQuotationId,
                //   quotationDetails: {
                //     number: list?.quotation?.quotation_number,
                //     name: list?.quotation?.name,
                //     type: list?.quotation_type,
                //     clientName: list?.client,
                //     clientSpecific: list?.quotation?.client?.client_specific,
                //     status: list?.quotation?.status,
                //     statusDate:
                //       list?.quotation?.status === "Approved"
                //         ? list?.quotation?.approved_date
                //         : list?.quotation?.status === "Rejected" &&
                //           list?.quotation?.rejected_date,
                //   },
                // }}
              >
                <button className="p-2 bg-red text-white rounded-md h-full">
                  <p className="flex gap-3 items-center">ADD PROFESSION</p>
                </button>
              </Link>
            )}
          {checkAccess("Quotation", "quotation-cost-sheet-list") && (
            <Link to={`notes`}>
              <button
                className={
                  currentList?.length <= 0
                    ? "p-2 bg-blue text-white rounded-md h-full opacity-50"
                    : "p-2 bg-blue text-white rounded-md h-full"
                }
                disabled={currentList?.length <= 0}
              >
                <p className="flex gap-3 items-center">Notes</p>
              </button>
            </Link>
          )}

          {/* {checkAccess("Quotation", "quotation-cost-sheet-list") && ( */}
          <Link to={`terms`}>
            <button
              className={
                currentList?.length <= 0
                  ? "p-2 bg-blue text-white rounded-md h-full opacity-50"
                  : "p-2 bg-blue text-white rounded-md h-full"
              }
              disabled={currentList?.length <= 0}
            >
              <p className="flex gap-3 items-center">TERMS AND CONDITIONS</p>
            </button>
          </Link>
          {/* )} */}
          {/* {checkAccess("Quotation", "quotation-cost-sheet-edit") && ( */}
          {contractDetails?.contract?.quotation_type?.name !== "Cost Plus" ? (
            <button
              onClick={() => setOpenHeadingEditPopup(true)}
              className={
                currentList?.length <= 0
                  ? "p-2 bg-blue text-white rounded-md h-full opacity-50"
                  : "p-2 bg-blue text-white rounded-md h-full"
              }
              disabled={currentList?.length <= 0}
            >
              EDIT HEADING
            </button>
          ) : (
            <button
              onClick={() => setOpenCostPlusHeadingEdit(true)}
              className={
                currentList?.length <= 0
                  ? "p-2 bg-blue text-white rounded-md h-full opacity-50"
                  : "p-2 bg-blue text-white rounded-md h-full"
              }
              disabled={currentList?.length <= 0}
            >
              EDIT HEADING
            </button>
          )}

          {/* )} */}

          {/* {checkAccess("Quotation", "quotation-cost-sheet-edit") && ( */}
          {contractDetails?.contract?.quotation_type?.name === "Cost Plus" && (
            <Link
              to={`cost-sheet-edit-fees-muqeem`}
              // state={{
              //   costSheetState: {
              //     govtFee:
              //       list?.quotation_type === "Cost Plus"
              //         ? "onetime_cost"
              //         : "monthly_cost",
              //     salaryAllowance: "monthly_cost",
              //     slaFees: "monthly_cost",
              //   },
              //   quotationId: currentQuotationId,
              //   quotationDetails: {
              //     number: list?.quotation?.quotation_number,
              //     name: list?.quotation?.name,
              //     type: list?.quotation_type,
              //     clientName: list?.client,
              //     clientSpecific: list?.quotation?.client?.client_specific,
              //     status: list?.quotation?.status,
              //     statusDate:
              //       list?.quotation?.status === "Approved"
              //         ? list?.quotation?.approved_date
              //         : list?.quotation?.status === "Rejected" &&
              //           list?.quotation?.rejected_date,
              //   },
              // }}
            >
              <button
                className={
                  currentList?.length <= 0
                    ? "p-2 bg-blue text-white rounded-md h-full opacity-50"
                    : "p-2 bg-blue text-white rounded-md h-full"
                }
                disabled={currentList?.length <= 0}
              >
                <p className="flex gap-3 items-center">
                  EDIT FEES PAYABLE AND MUQEEM POINTS
                </p>
              </button>
            </Link>
          )}

          {/* )} */}
        </div>
        <button
          className={
            currentList.length <= 0 ? "cursor-not-allowed" : "cursor-pointer"
          }
          disabled={currentList?.length <= 0}
          onClick={() => setShowSettings(true)}
        >
          <IoSettingsOutline size={"1.2rem"} />
        </button>
      </div>
      <p className="text-sm mt-5 w-full text-right font-medium xl:hidden">{`Slide / scroll to right >`}</p>
      <div
        className={` bg-slate-50 shadow rounded-lg px-1 transition-all w-full min-w-full py-5 h-auto my-4 `}
      >
        {/* <Search
            keywords={["job_position.name", "nationality.name", "quantity"]}
          /> */}
        <div
          className={`rounded-md overflow-x-scroll py-5 flex flex-col bg-white p-3 mb-2`}
        >
          <div className="flex justify-between gap-5 min-w-full w-fit">
            <p className={`font-semibold w-full min-w-[4rem] max-w-[5rem]`}>
              Sl No.
            </p>
            {selectedFields.map((selectedData) => (
              <p
                key={selectedData.id}
                className={`font-semibold w-full ${selectedData.width}`}
              >
                {selectedData?.title}
              </p>
            ))}
            <p className={`font-semibold w-full min-w-fit max-w-[6rem]`}>
              Action
            </p>
          </div>
          {list.length <= 0 && !dataLoaded && <LoadingWithLable />}
          {list.length <= 0 && dataLoaded && (
            <p className="w-full flex justify-center mt-5">No data found</p>
          )}
          <div className="min-w-full w-fit  flex flex-col gap-y-3 mt-4">
            {currentList.map((data, index) => (
              <div key={index} className="flex flex-col gap-3">
                <div className="flex justify-between gap-5 min-w-full w-fit">
                  <p className=" w-full min-w-[4rem] max-w-[5rem]">
                    {index + 1}
                  </p>
                  {selectedFields.map((selectedData) => (
                    <p
                      className={`w-full ${selectedData.width}`}
                      key={selectedData?.id}
                    >
                      {getNormalizedValue(data, selectedData)}
                    </p>
                  ))}

                  <div className="flex items-start gap-2  w-full min-w-fit max-w-[6rem]">
                    {checkAccess("Quotation", "quotation-cost-sheet-edit") && (
                      <button
                        className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                        onClick={() => editData(data.id)}
                      >
                        <CiEdit size={"1.4rem"} />
                      </button>
                    )}

                    {checkAccess(
                      "Quotation",
                      "quotation-cost-sheet-delete"
                    ) && (
                      <button
                        className="p-1 px-2 rounded-md ring-1 ring-red text-white text-center bg-red"
                        onClick={() =>
                          setDeletePopup({ open: true, id: data.id })
                        }
                      >
                        <MdDeleteOutline size={"1.4rem"} />
                      </button>
                    )}
                  </div>
                </div>
                <hr className="border-[1.5px] border-slate-100  min-w-full" />
              </div>
            ))}
          </div>
        </div>
        <Pagination />
      </div>
    </>
  );
};

export default ContractCostSheetTable;
